// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArEigjWnOTmwepldeJ6jMI345iTifF7_E",
  authDomain: "bwi-meet-minutes.firebaseapp.com",
  projectId: "bwi-meet-minutes",
  storageBucket: "bwi-meet-minutes.appspot.com",
  messagingSenderId: "289299350152",
  appId: "1:289299350152:web:d0f29743a7aaf2b7b5953d",
  measurementId: "G-9XJ7RY5MQH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);
